import _ from 'underscore';
import selectorTemplate from './template/selector.pug';

function normalizeClasses(classes) {
  if (_.isArray(classes)) {
    return classes;
  } else if (_.isString(classes)) {
    return classes.split(' ');
  }
  return [];
}

/**
 * Render a dropdown selector
 *
 * @this ToolbarView
 * @param {object} selector - selector configuration object.
 * @param {function} renderItem - callback to render a sub toolbar item.
 * @returns {RenderResult} - render result
 */
export function renderSelector(selector = {}, renderItem) {
  const {
    classes = [],
    id = _.uniqueId('selector-'),
    items = [],
    selectedKey = _.result(_.first(items), 'key'),
    onChange = _.noop,
    checkKeyDifferenceOnClick = true,
    button = {},
    tabindex,
  } = selector;
  const selectedItem = _.find(items, i => i.key === selectedKey) || _.first(items);

  const html = selectorTemplate({
    id,
    classes,
    dropdownHtml: renderItem({
      type: 'dropdown',
      button: _.extend(button, {
        text: _.result(selectedItem, 'text', 'N/A'),
      }),
      tabindex,
      menu: {
        items: _.map(items, item => ({
          text: item.text,
          id: item.id,
          classes: normalizeClasses(item.classes).concat(item.key === selectedKey ? ['selected'] : []),
          onClick() {
            if (!checkKeyDifferenceOnClick || item.key !== selectedKey) {
              this.update({ id, selectedKey: item.key, value: item.value });
              onChange(item);
            }
          },
        })),
      },
    }),
  });

  return { html };
}
